import {HelpModalHelpCenter} from '#components';

export function useHelpActions() {

  return {
    openHelpModal({toVideo} = {}) {
      useFModal({
        id: 'help-center',
        size: 'xl',
        component: HelpModalHelpCenter,
        props: {
          toVideo
        }
      }).open();
    }
  }
}
